import { Validation } from "@/data/util/Validation";

import { trans } from "@/app/localization/Trans";

export class EmailInput {
    public $input: JQuery;
    private $element: JQuery;
    private $icon: JQuery;
    private isVerified?: boolean;

    public onFocus?: { (hasFocus: boolean)};

    constructor(indent?: boolean) {
        this.$element = $(
            `<div class="emailinput formcontrol${indent === true ? " intent" : ""}"><label>${trans.signin.email}</label></div>`
        );
        this.$input = $('<input type="text" name="email" autocomplete="off" />').appendTo(this.$element);
        this.$icon = $('<div class="icon"><i class="fas fa-check"></i></div>').appendTo(this.$element);
        this.$input
            .keyup(() => this.checkEmailInput())
            .focus(() =>{ this.$element.addClass("editing");
                if (this.onFocus) { this.onFocus(true); }
            })
            .blur(() => {
                this.checkEmailInput(true);
                this.$element.removeClass("editing");

                if (this.onFocus) { this.onFocus(false); }
            });
    }

    public isValid(): boolean {
        return Validation.isEmail(this.getValue());
    }

    public setValue(email: string): EmailInput {
        this.$input.val(email);
        this.checkEmailInput();
        return this;
    }

    public getValue(): string {
        return this.$input.val().length === 0 ? undefined : this.$input.val();
    }

    public setVerified(isVerified?: boolean) {
        this.isVerified = isVerified;
        if (this.isVerified === undefined) {
            this.$element.removeClass("hasconfirmation").find("> .state").remove();
            this.$icon.show();
        } else {
            this.$element.addClass("hasconfirmation");
            let state = this.$element.find("> .state");
            if (state.length === 0) state = $('<div class="state" />').appendTo(this.$element);

            state.removeClass("confirmed unconfirmed");
            if (isVerified) state.addClass("confirmed").html(trans.profile.emailConfirmed);
            else state.addClass("unconfirmed").html(trans.profile.emailUnconfirmed);

            this.$icon.hide();
        }
    }

    public onKeyUp(handler: { (nv: string) }) {
        this.$input
            .unbind("keyup")
            .bind("keyup", () => {
                handler(this.getValue());
            })
            .unbind("change")
            .bind("change", () => {
                handler(this.getValue());
            });
    }

    public setError(hasError: boolean): EmailInput {
        if (hasError) this.$element.addClass("has-error");
        else this.$element.removeClass("has-error");

        return this;
    }

    public appendTo($element: JQuery): EmailInput {
        this.$element.appendTo($element);

        return this;
    }

    private checkEmailInput(removeWhiteSpace?: boolean) {
        if (removeWhiteSpace !== undefined && removeWhiteSpace === true) {
            const val = this.getValue();
            if (val !== undefined) this.$input.val(val.replace(/\s+/g, ""));
        }

        const val = this.getValue();

        if (val !== undefined && val != null) this.$element.addClass("edited");
        else this.$element.removeClass("edited");

        if (this.isVerified !== undefined) return;

        const hasClass = this.$icon.hasClass("active");
        const isEmail = this.isValid();
        if (!hasClass && isEmail) {
            this.$icon.addClass("active");
            this.setError(false);
        } else if (hasClass && !isEmail) this.$icon.removeClass("active");
    }
}
